import BasedModal from "components/BaseModalComponents/BasedModal";
import { IProps } from "components/BaseModalComponents/BasedModal";
import { GreenButton } from "components/Buttons/buttonsStyles";
import React from "react";
import { Container, modalStyle } from "../settingsModalStyles";

const WarningEditSessionModal: React.FC<IProps> = ({
    isOpen,
    onRequestClose,
}) => {
    return (
        <BasedModal
            style={modalStyle}
            isOpen={isOpen}
            onRequestClose={onRequestClose}
        >
            <Container>
                <p>
                    Через 1 минуту ваша сессия редактирования тикера, длиною в
                    10 минут, деактивируется! Нажмите на уведомление или
                    вернитесь во вкладку, чтобы продолжить редактирование
                    тикера!
                </p>
                <GreenButton onClick={onRequestClose}>ОК</GreenButton>
            </Container>
        </BasedModal>
    );
};

export default WarningEditSessionModal;
